<template>
  <div id="app">
    <figure class="main-logo">
      <img class="img-fluid" src="./assets/hak4t-logo.png" alt="Hak4t - Brightest Light Solutions">
    </figure>
    <router-view></router-view>
  </div>
</template>

<script>
    export default {
        name: 'app'
    }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,700,900');

  $primary: #3B90BA;

  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/dist/bootstrap-vue.css';

  html {
    scroll-behavior: smooth;
  }

  body {
    background: #43454F url(assets/bg.jpg) 0 0 no-repeat;
    background-size: 100% auto;
    font-family: 'Montserrat', sans-serif;
    -webkit-font-smoothing: antialiased;
    padding-bottom: 40px;
  }

  @media only screen and (min-width: 768px) {

    body {
      padding-left: 190px;
      padding-top: 20px;
    }
  }

  @media only screen and (min-width: 1200px) {

    html {
      padding-top: 40px;
      padding-bottom: 40px;
      min-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    body {
      padding-right: 190px;
      flex-grow: 1;
    }
  }

  h1,
  h2
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    line-height: 0.976;
  }

  h1 {
    color: #FFF;
    font-size: 1.625rem;
  }

  @media only screen and (min-width: 768px) {

    h1 {
      font-size: 2.625rem;
    }
  }

  .main-logo {
    width: 80px;
    margin: 20px auto 10px 20px;

  }

  @media only screen and (min-width: 768px) {

    .main-logo {
      width: auto;
      height: auto;
      position: absolute;
      margin: 0;
      left: 40px;
      top: 30px;
    }
  }

  .main-content-inner {
    position: relative;
    background: #FFF;
    box-shadow: 0 1px 3px 1px rgba(0,0,0,0.15);
    border-radius: 4px;
  }


  /* Widths */

  .mw-630 {
    max-width: 630px;
  }
  
  /* Highlighted */
  
  .highlighted {
    background-color: #E0555B;
    color: #FFF;
    padding: 5px;
    margin-bottom: -5px;
    margin-top: -5px;
    display: inline-block;
    vertical-align: baseline;
  }

  @media only screen and (min-width: 768px) {

    .highlighted {
      margin-left: -10px;
      margin-right: -10px;
    }
  }


  /* Form style */

  .form-group {
    margin-bottom: 10px;
  }

  label {
    cursor: pointer;
  }

  .form-control {
    background: #FEFEFE;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    box-shadow: 0 1px 3px 1px rgba(0,0,0,0.16) !important;
  }

  .form-control::placeholder {
    color: #ACACAC;
  }

  @media only screen and (min-width: 768px) {

    .form-control {
      height: 87px;
      padding-left: 40px;
      padding-right: 40px;
      min-width: 500px;
      font-size: 22px;
    }
  }


  /* Fancy select */

  .fancy-select {
    position: relative;
  }

  .fancy-select select {
    cursor: pointer;
    appearance: none;
    padding-right: 40px;
  }

  /*select {*/
    /*color: #ACACAC !important;*/
  /*}*/

  .fancy-select::after {
    position: absolute;
    display: block;
    content: "";
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
    width: 32px;
    height: 32px;
    pointer-events: none;
    background: url(./assets/select-arrow.svg) 50% 50% no-repeat;
  }

  @media only screen and (min-width: 768px) {

    .fancy-select::after {
      right: 20px;
    }
  }
  
  
  /* Btn */

  .btn {
    font-weight: bold;
  }


  @media screen and (max-width: 767px) {

    body {
      background-image: url(assets/bg-mobile.jpg);
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue